<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card id="loading-block" class="vs-con-loading__container" :collapse-action="true" title="Company Ranks">
      <SlickList class="mb-2" lockAxis="y" :distance="5" v-model="workingRanks" @input="onRanksSorted">
<!--        <vs-list>-->
          <SlickItem v-for="(rank, index) in workingRanks" :index="index" :key="rank.id">
            <vs-alert class="p-0 mb-1" color="#EAEAEA">
              <vs-icon size="25px" color="#e5e5f9" class="float-left" style="cursor:grab;" icon="menu"></vs-icon>
              <span class="label ml-3 text-dark">{{ rank.name }}</span>
              <vs-button class="float-right" type="line" size="small" @click="prepRankForLocalizationEdit(rank)" color="primary" icon="edit" ></vs-button>
              <vs-button class="float-right mx-2" type="line" size="small" @click="confirmDeleteRank(rank)" color="danger" icon="delete" ></vs-button>
            </vs-alert>
          </SlickItem>
<!--        </vs-list>-->
      </SlickList>

      <div class="vx-row">
        <div class="vx-col w-full my-2">
          <vs-button class="float-right" color="primary" type="border" icon-after icon="add" @click="showNewRankDialog = true">New Rank</vs-button>
        </div>
      </div>

      <vs-prompt
        buttons-hidden
        :title="rankToEdit.name"
        :active.sync="showRankLocalizationsDialog">
        <div class="modal-lg">
          <CompanyRankLocalizationCard :rank="rankToEdit"
                                       v-on:rankUpdated="updateRank"
          ></CompanyRankLocalizationCard>
        </div>
      </vs-prompt>

      <vs-prompt
        buttons-hidden
        title="Add Rank"
        :active.sync="showNewRankDialog">
        <div class="modal-lg">
          <AddCompanyRankCard :company="company"
                              :order="highestOrderNumber + 1"
                                       v-on:rankCreated="addRank"
          ></AddCompanyRankCard>
        </div>
      </vs-prompt>

    </vx-card>


</template>

<script>
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter'
  import {productHelpers} from '@/models/helpers';
  import api from '@/http/api';
  import { SlickList, SlickItem } from 'vue-slicksort';
  import CompanyRankLocalizationCard from './CompanyRankLocalizationsCard';
  import AddCompanyRankCard from './AddCompanyRankCard';

  export default {
    // mixins: [
    //   ContainerMixin,
    //   ElementMixin
    // ],
    components: {
      SlickList,
      SlickItem,
      CompanyRankLocalizationCard,
      AddCompanyRankCard,
    },
    data() {
      return {
        types: types,
        jsonHtml: jsonHtml,
        showNewRankDialog: false,
        showRankLocalizationsDialog: false,
        rankToEdit: new types.CompanyRank(),
        helpers: productHelpers,
        workingRanks: [],
        highestOrderNumber: 0,
      }
    },
    props: {
      company: {
        type: types.Company(),
        required: true,
        default: () => {
          return new types.Company()
        }
      },
    },
    watch: {
      company: function (newVal, oldVal) {
        if (JSON.stringify(newVal.ranks) === JSON.stringify(oldVal.ranks)) return;
        this.setRankCopies(newVal.ranks);
      },
    },
    computed: {
      localizedProperties() {
        return this.workingRanks.filter((prop) => { return prop.language_id === this.language.language_id});
      }
    },
    methods: {
      confirmDeleteRank(rank) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          acceptText: 'DELETE',
          title: `DELETE ${rank.name}`,
          text: `Are you sure you want to delete this rank?`,
          accept: () => {
            this.deleteRank(rank);
          }
        })
      },
      async deleteRank(rank) {
        const success = api.deleteCompanyRank(rank);
        if (!success) {
          this.showNotification(false, 'error deleting rank');
          return;
        }
        // const refreshedCompany = await api.fetchCompany(this.company.company_id);

        this.showNotification(true, `Rank "${rank.name}" Deleted`);
        // update the rank list with the deleted rank removed.
        this.setRankCopies(this.workingRanks.filter((r) => r.id !== rank.id));
      },
      prepRankForLocalizationEdit(rank) {
        this.rankToEdit = new types.CompanyRank(rank);
        this.showRankLocalizationsDialog = true;
      },
      showSpinnerOverCard(){
        this.$vs.loading({
          container: '#loading-block',
          scale: 0.6
        });
        setTimeout( ()=> {
          this.hideSpinnerOverCard();
        }, 3000);
      },
      hideSpinnerOverCard() {
        this.$vs.loading.close('#loading-block > .con-vs-loading')

      },
      setRankCopies(rankList) {
        let temp = JSON.parse(JSON.stringify(rankList));
        if (temp.length > 0) {
          temp.sort((a,b) => a.order - b.order);
          this.highestOrderNumber = temp[temp.length - 1].order;
        }
        this.workingRanks = temp;
      },
      async onRanksSorted(sorted) {
        this.showSpinnerOverCard();

        // put all the modified ranks into a list
        let newRanks = [];
        for (let i=0; i<sorted.length; i++) {
          let rankToUpdate = this.workingRanks.filter((it) => it.id === sorted[i].id)[0];
          if (rankToUpdate.order !== i) {
            rankToUpdate.order = i;
            newRanks.push(rankToUpdate);
          }
        }
        // patch the changes (if any)
        if (newRanks.length > 0) {
          let resultRanks = await api.patchCompanyRanksOrder(this.company, newRanks);
          this.setRankCopies(resultRanks);
        }
        this.hideSpinnerOverCard();
      },
      updateRank(newRank) {
        for (let i = 0; i<this.workingRanks.length; i++) {
          let rank = this.workingRanks[i];
          if (rank.id === newRank.id) {
            this.workingRanks[i] = newRank;
            return;
          }
        }
      },
      addRank(newRank) {
        if (!newRank) return;
        this.workingRanks.push(newRank);
        this.setRankCopies(this.workingRanks);
        this.showNewRankDialog = false;
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    }
  }
</script>

<style lang="css" scoped>
  .fill-row-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
</style>
